// extracted by mini-css-extract-plugin
export default {"pane":"Conversations-module__pane--iI8ko"};